module.exports = __webpack_public_path__ + "img/PS15.13bdc194.png";